import { ChatSuggestions } from '#app/features/chat/components/suggestions.tsx'

export const EmptyChat = ({ messageFetcher, textareaRef }: any) => (
	<div className="mx-4 h-full items-center justify-center gap-3 pt-5 lg:mx-auto lg:w-full lg:max-w-2xl lg:pt-6 xl:max-w-3xl">
		<ChatSuggestions
			messageFetcher={messageFetcher}
			textareaRef={textareaRef}
		/>
	</div>
)
